import React from "react";

const MobileAppSVG = ({isActive}) => {
  if (isActive) {
    return (
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="40" height="40" rx="4" fill="#FAE1E6"/>
        <path
          d="M16 13C16 11.3431 17.3431 10 19 10H27C28.6569 10 30 11.3431 30 13V27C30 28.6569 28.6569 30 27 30H19C17.3431 30 16 28.6569 16 27V13Z"
          fill="#DE6766"/>
        <path
          d="M10 15C10 13.8954 10.8954 13 12 13H22C23.1046 13 24 13.8954 24 15V21C24 22.1046 23.1046 23 22 23H12C10.8954 23 10 22.1046 10 21V15Z"
          fill="#EFA397"/>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M20 27C20 26.4477 20.4477 26 21 26H25C25.5523 26 26 26.4477 26 27C26 27.5523 25.5523 28 25 28H21C20.4477 28 20 27.5523 20 27Z"
              fill="#A23736"/>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M19.6709 15.4587C20.0805 15.8292 20.1121 16.4616 19.7415 16.8711L17.0273 19.8711C16.8445 20.0731 16.5873 20.1918 16.3151 20.1998C16.0429 20.2078 15.7792 20.1044 15.5849 19.9135L14.2992 18.6504C13.9052 18.2633 13.8996 17.6302 14.2867 17.2362C14.6737 16.8423 15.3069 16.8367 15.7008 17.2237L16.2433 17.7566L18.2585 15.5293C18.629 15.1198 19.2614 15.0881 19.6709 15.4587Z"
              fill="white"/>
      </svg>
    )
  }

  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="4" fill="#F4F4F4"/>
      <path
        d="M15 13C15 11.3431 16.3431 10 18 10H26C27.6569 10 29 11.3431 29 13V27C29 28.6569 27.6569 30 26 30H18C16.3431 30 15 28.6569 15 27V13Z"
        fill="#C3C2C7"/>
      <path
        d="M11 15C11 13.8954 11.7675 13 12.7143 13H21.2857C22.2325 13 23 13.8954 23 15V21C23 22.1046 22.2325 23 21.2857 23H12.7143C11.7675 23 11 22.1046 11 21V15Z"
        fill="#2C2C2F"/>
      <path fillRule="evenodd" clipRule="evenodd"
            d="M19 27C19 26.4477 19.4477 26 20 26H24C24.5523 26 25 26.4477 25 27C25 27.5523 24.5523 28 24 28H20C19.4477 28 19 27.5523 19 27Z"
            fill="#2C2C2F"/>
      <path fillRule="evenodd" clipRule="evenodd"
            d="M19.6709 15.7585C20.0805 16.129 20.1121 16.7614 19.7415 17.1709L17.0273 20.1709C16.8445 20.3729 16.5873 20.4916 16.3151 20.4996C16.0429 20.5076 15.7792 20.4042 15.5849 20.2133L14.2992 18.9502C13.9052 18.5631 13.8996 17.93 14.2867 17.536C14.6737 17.1421 15.3069 17.1365 15.7008 17.5235L16.2433 18.0564L18.2585 15.8291C18.629 15.4196 19.2614 15.3879 19.6709 15.7585Z"
            fill="white"/>
    </svg>
  )
};

export default MobileAppSVG;
